import { AppearanceType } from '@comet/blocks';
const appearances: AppearanceType[] = ['warning', 'danger', 'info', 'success'];

export const getRandomAppearance = () => {
  const randomIndex = Math.floor(Math.random() * appearances.length);
  return appearances[randomIndex];
};
